module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/7548eab67bb6177efa2f8a1ab3149155.png";